<template>
  <div class="scence" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content">
      <div class="skt" ref="skt">
        <div class="select">
          <span class="xzqh">塘（堰）坝名称:</span>
          <div class="selcountry">
            <el-input v-model="damname" clearable placeholder="请输入名称" @change="Global.emptyQuery(damname,searchtown)"></el-input>
          </div>
          <span id="search" @click="searchtown">查询</span>
          <span v-if="allowsPerm.delete" id="del" @click="delDialog(multipleSelection)"><span class="del-icon"></span>删除</span>
          <span v-if="allowsPerm.update" id="edit" @click="editDialog"><span class="edit-icon"></span>编辑</span>
          <span v-if="allowsPerm.insert" id="add" @click="addDialog"><span class="add-icon"></span>新增</span>
          <!-- <span id="add"><span class="add-icon"></span>新增</span> -->
        </div>
        <div class="tablebox">
          <div class="fzxxtable">
            <el-table ref="multipleTable" @row-click="clickRow" v-loading="loading" :data="tdata" :max-height="height" border @selection-change="handleSelectionChange" style="width: 100%; text-align: center;">
              <el-table-column type="selection" width="40" align="center">
              </el-table-column>
              <el-table-column type="index" width="60" label="序号"
                               align="center" header-align="center"
                               :index='(index)=>{return (index+1) + (pageIndex-1)*pageSize }'>
              </el-table-column>
              <el-table-column  prop="adcdnm" label="乡镇" min-width="120" align="left" header-align="left">
              </el-table-column>
              <el-table-column prop="damName" label="塘（堰）坝名称" min-width="120" align="left" header-align="left">
              </el-table-column>
              <el-table-column prop="canm"  label="所属小流域" min-width="100" align="left" header-align="left">
              </el-table-column>
               <el-table-column prop="lng"  label="经度" min-width="100" align="right" header-align="center">
              </el-table-column>
               <el-table-column prop="lat"  label="纬度" min-width="100" align="right" header-align="center">
              </el-table-column>
              <el-table-column prop="damType" label="挡水主坝类型" min-width="100" align="left" header-align="left">
              </el-table-column>
              <el-table-column prop="storage" label="总库容（m³）" min-width="100" align="right" header-align="center">
              </el-table-column>
              <el-table-column prop="damHeight" label="坝高（m）" min-width="100" align="right" header-align="center">
              </el-table-column>
              <el-table-column prop="damLength" label="坝长（m）" min-width="100" align="right" header-align="center">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <pager
            @current-change="onCurrentChange"
            @size-change="onSizeChange"
            :pageIndex="pageIndex"
            :pageSize="pageSize"
            :total="total"
        ></pager>
      </div>
    </div>
     <el-dialog
      class="abow_dialog"
      :title="status + '塘（堰）坝信息'"
      :close-on-click-modal="false"
      :visible.sync="addbtn"
     >
      <el-form ref="groupForm" :model="form" :rules="rules" label-width="170px" label-height="40px">
        <el-form-item label="乡镇:" prop="adcdid">
           <el-cascader
            v-model="form.adcdid"
            separator="-"
            :options="mutiRanksAdcd"
            :props="{ expandTrigger: 'hover' }"
            @change="handleChange">
          </el-cascader>
        </el-form-item>
        <el-form-item label="塘（堰）坝名称:" prop="damName">
          <el-input v-model="form.damName"></el-input>
        </el-form-item>
        <el-form-item label="所属小流域:" prop="canm">
          <el-select v-model="form.cacd" filterable clearable placeholder="请选择">
            <el-option
              v-for="(item, index) in cacds"
              :key="index"
              :label="item.canm"
              :value="item.cacd">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="经度:" prop="lng">
          <el-input v-model="form.lng"></el-input>
        </el-form-item>
        <el-form-item label="纬度:" prop="lat">
          <el-input v-model="form.lat"></el-input>
           <DrawPoint :globalmapId='globalmapId' :latlng='latlngarr' @changeAdd='handleChangeAdd'></DrawPoint>
        </el-form-item>
        <el-form-item label="挡水主坝类型:" prop="damType">
          <el-input v-model="form.damType"></el-input>
        </el-form-item>
        <el-form-item label="总库容:" prop="storage">
          <el-input v-model="form.storage"></el-input>
          <label>(m³)</label>
        </el-form-item>
        <el-form-item label="坝高:" prop="damHeight">
            <el-input v-model="form.damHeight"></el-input>
            <label class="num">(m)</label>
        </el-form-item>
        <el-form-item label="坝长:" prop="damLength">
          <el-input v-model="form.damLength"></el-input>
          <label>(m)</label>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addbtn = false">取 消</el-button>
        <el-button type="primary" @click="onGroupSave">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import scenceTypes from '@/store/types/scence'
import monitorTypes from '@/store/types/monitor'
import baseTypes from '@/store/types/base'
import Pager from '@/components/Pager'
import DrawPoint from '@/components/DrawPoint'
export default {
  name: 'Scence',
  props: ['addvcd'],
  components: {
    Pager,
    DrawPoint
  },
  data () {
    return {
      damname: '',
      value1: '',
      loading: true,
      height: 10,
      form: { name: '' },
      aDCD: '330324',
      aDDVCD: '',
      checkarr: [],
      adcdtotal: '',
      mutiRanksAdcd: [],
      cACD: '',
      addbtn: false,
      adcdval: [],
      adcds: [],
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      tdata: [],
      isTown: true,
      all: true,
      searchName: '',
      delId: [],
      multipleSelection: [],
      status: '新增',
      valueId: '',
      cPageIndex: '1',
      cPageSize: '100',
      cacds: [],
      globalmapId: 'baseInfo',
      latlngarr: [],
      lat: 28.273886, // 新增初始经纬度坐标
      lng: 120.690968,
      rules: {
        adcdid: [
          { required: true, message: '请选择乡镇', trigger: 'change' }
        ],
        cacd: [
          { required: true, message: '请选择所属小流域' }
        ],
        damName: [
          { required: true, message: '塘（堰）坝名称不能为空', trigger: 'blur' }
        ],
        damType: [
          { required: true, message: '挡水主坝类型不能为空', trigger: 'blur' }
        ],
        lng: [
          { validator: this.Global.checkNumeral }
        ],
        lat: [
          { validator: this.Global.checkNumeral }
        ],
        storage: [
          { required: true, message: '总库容不能为空' },
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        damHeight: [
          { required: true, message: '坝高不能为空' },
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        damLength: [
          { required: true, message: '坝长不能为空' },
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    addvcd (val, oldVal) { // 普通的watch监听
      this.loading = true
      this.pageIndex = 1 // 查询重置页码
      this.aDDVCD = val
      this.thedata()
    }
  },
  computed: {
    allowsPerm: {
      get () {
        return this.$store.state.allowPerm
      },
      set () {
        this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
      }
    }
  },
  methods: {
    handleChangeAdd (data) {
      // this.form.lng = data.lng
      // this.form.lat = data.lat
      this.form.lng = this.$set(this.form, 'lng', data.lng)
      this.form.lat = this.$set(this.form, 'lat', data.lat)
    },
    onSizeChange (pageSize) {
      this.pageIndex = 1
      this.pageSize = pageSize
      this.thedata()
    },
    onCurrentChange (pageIndex) {
      this.pageIndex = pageIndex
      this.thedata()
    },
    //  行选中
    clickRow (row) {
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    thedata () {
      this.loading = true
      this.$store.dispatch(scenceTypes.GET_DAM, {
        aDCD: this.aDDVCD,
        cACD: this.cACD,
        searchName: this.damname,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }).then(data => {
        this.tdata = data.results
        this.total = data.total
        this.loading = false
      })
    },
    adcddata () {
      this.$store.dispatch(monitorTypes.GET_ADCD, {
        isTown: this.isTown,
        searchName: this.searchName,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }).then(data => {
        this.adcdtotal = data.results.length
        this.adcds = data.results
      })
    },
    getCacd () {
      this.$store.dispatch(baseTypes.GET_CACD, { pageIndex: this.cPageIndex, pageSize: this.cPageSize }).then(data => {
        this.cacds = data.results
      }).catch(() => {})
    },
    adcdchange (adcd) {
      this.aDCD = adcd.substring(0, 9)
    },
    searchtown () {
      this.pageIndex = 1 // 查询重置页码
      // this.setAllCheck()
      this.thedata()
    },
    handleSelectionChange (val) {
      this.multipleSelection = JSON.parse(JSON.stringify(val))
      console.log(this.multipleSelection)
    },
    // 新增
    addDialog () {
      this.status = '新建'
      this.latlngarr = [] // 重置经纬度
      this.form = {}
      // this.form = Object.assign({}, { lat: this.lat, lng: this.lng })
      // this.latlngarr.push(this.lng, this.lat)
      this.addbtn = true
      this.Global.clearValidate(this, 'groupForm')
    },
    // 编辑
    editDialog () {
      this.status = '编辑'
      if (this.multipleSelection.length < 1) {
        this.$alert('需要选择一条数据才可进行该操作！请选择其中一条数据。', '提示')
      } else if (this.multipleSelection.length > 1) {
        this.$alert('该操作不可对多条数据同时进行操作。', '提示')
      } else {
        this.latlngarr = [] // 重置经纬度
        this.form = {}
        this.addbtn = true
        this.form = Object.assign({}, this.multipleSelection[0])
        this.latlngarr.push(this.form.lng, this.form.lat)
        this.Global.clearValidate(this, 'groupForm')
      }
    },
    // 删除
    delDialog (rows) {
      if (rows < 1) {
        this.$alert('请先勾选需要删除的数据项！', '提示')
      } else {
        this.delId = [] // 清空数组
        rows.forEach(item => {
          this.delId.push(item.id)
        })
        console.log(this.delId)
        this.$confirm(`确定要删除已选择的塘（堰）坝信息 ?`, '确认').then(() => {
          this.loading = true
          this.$store.dispatch(scenceTypes.DELETE_DAM, { id: this.delId.join(',') }).then(() => {
            this.loading = false
            this.$notify.success({ title: '成功', message: '删除数据成功.' })
            this.thedata()
          }).catch(() => { this.loading = false })
        }).catch(() => {})
      }
    },
    // 保存新增/编辑
    onGroupSave () {
      this.$refs['groupForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.form.aDCDID = this.valueId
          console.log(this.form, '保存表单')
          this.$store.dispatch(scenceTypes.SAVE_DAM, this.form).then(() => {
            this.loading = false
            this.addbtn = false
            this.$notify.success({ title: '成功', message: '保存成功。' })
            this.thedata()
            this.form = {}
          }).catch(() => { this.loading = false })
        }
      })
    },
    handleChange (val) {
      var valueIndex = val.length
      this.valueId = val[valueIndex - 1]
    },
    // 获取三级联动数据
    getMutiRanksAdcd () {
      this.$store.dispatch(scenceTypes.GET_MUTIRANKS_ADCD, {
        parentAdcdCode: this.aDCD
      }).then(data => {
        console.log(data)
        this.mutiRanksAdcd = data.results
      })
    }
  },
  created () {
    this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
  },
  mounted () {
    this.thedata()
    this.adcddata()
    this.getCacd()
    this.getMutiRanksAdcd()
    this.$nextTick(() => {
      let sktDiv = document.getElementsByClassName('skt')
      this.height = sktDiv[0].offsetHeight - 120
    })
  }
}
</script>
<style lang="less" src="@/assets/scene.less" scoped>
</style>
<style scoped>
.scence .content{
  padding: 0!important;
}
.scence .skt{
  height: calc(100% - 139px);
}
.countryList{
  /* width: 100%; */
  height: 62px;
  background-color: #ffffff;
  border-radius: 5px;
  color: #444444;
  font-size: 15px;
  /* margin-top: 15px; */
}
.country{
  float: left;
  font-family: Microsoft YaHei UI;
  font-size: 15px;
  text-align: center;
  margin-top: 20px;
  margin-left: 0.5%;
  cursor: pointer;
}
.countryon{
  border-radius: 15px;
  background-color: #fda72c;
  color: #ffffff
}
.country span{
  padding: 4px 15px;
}
.scence >>> .el-dialog__body .el-form-item .el-form-item__content {
  width: 62%;
}
.scence >>> .el-dialog__body .el-form-item .el-form-item__content .el-input {
    width: 75%;
}
.scence >>> .el-dialog__body .el-form-item .el-form-item__content label {
    margin-left: 5px;
}
.scence >>> .el-dialog__body {
  height: 70%;
  left: 0;
  top: 54px;
  bottom: 0;
  right: 0;
  z-index: 1;
  overflow: hidden;
  overflow-y: auto;
}
.scence >>> .el-dialog {
  margin: 0 auto !important;
}
.scence >>> .el-table__body,.scence >>> .el-table__header{
  width: auto!important;
}
.scence >>> .del_dialog .el-dialog__body .del_tip{
  display: block;
  width: 80%;
  font-size: 18px;
  margin: 10% auto;
  text-align: center;
}
.global_map {
  position: absolute;
  right: 15px;
  top: 5px;
}
.scence >>>.el-form-item__content{
  width: 65%!important;
}
</style>
